import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckBlacklistForm } from "@/components/forms/check-blacklist-form";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import type { SERVICES } from "@/lib/constants";

export const CheckBlacklistModal = ({
  service,
  children,
}: {
  service: Exclude<
    (typeof SERVICES)[number],
    { label: "EASI Tourist" } | { label: "EASI Recaj" }
  >;
  children: React.ReactNode;
}) => {
  const { t } = useTranslation();

  const [isOpen, onOpenChange] = useState(false);

  return (
    <Dialog onOpenChange={onOpenChange} open={isOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="sr-only">
            {t("check-blacklist.title")}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t("check-blacklist.description")}
          </DialogDescription>
        </DialogHeader>

        <CheckBlacklistForm
          className="space-y-6"
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          service={service}
        />
      </DialogContent>
    </Dialog>
  );
};
